import { configureStore } from '@reduxjs/toolkit'
import languageReducer from './languageReducer';

export default configureStore({
    reducer: {
        currentLanguage: languageReducer
    }
})